// Importaciones previas...
import { useEffect, useState } from 'react';
import useDataBean from '../../../../core/services/dataBean/useDataBean';
import { _AbstractAccount, _Affiliate, _single, _ThirdBankingAccount } from '../../../../core/services/dataBean/EntityCatalog';
import { toast } from 'react-toastify';
import { PersonalInfoTab } from '../../../../portal/componets/pages/IndexPage/Components/PersonarDataUser/Components/PersonalInfoTab';
import { PersonalReferenceTab } from '../../../../portal/componets/pages/IndexPage/Components/PersonarDataUser/Components/PersonalReferenceTab';
import { PersonalDocumentsTab } from '../../../../portal/componets/pages/IndexPage/Components/PersonarDataUser/Components/PersonalDocumentTab';
import { BasicButton } from '../../../theme/Component/BasicButton';
import { ThirdBankingAccount } from '../../../Talentohumano/ParametrosTalentoHumano/ThirdBankingAccount/ThirdBankingAccount';
import { CardTaps } from '../../../theme/Component/CardTaps';
import { Alert } from '../../../theme/Component/Alert';

interface Props {
    onClickSave?: Function;
    showOnlyTabId?: number;
    idAffiliate?: number;
    type?: number[];
    _PayrollType?: number;
    _LoanLine?: number;
}

export const PersonalAccountDataInfo = ({ onClickSave, showOnlyTabId, idAffiliate, type = [100, 101], _LoanLine, _PayrollType }: Props) => {
    const { instance, bean, setBean } = useDataBean(_Affiliate);
    const accF = useDataBean(_AbstractAccount);
    const [props, setProps] = useState<any>({});
    const [missingFields, setMissingFields] = useState<string[]>([]);
    const [indexTap, setIndexTap] = useState(0);

    useEffect(() => {
        if (idAffiliate) {
            getAffiliate(idAffiliate);
        }
    }, [idAffiliate]);


    useEffect(() => {
        if (bean?.JSONProps) {
            setProps(JSON.parse(bean.JSONProps));
        }
    }, [bean.JSONProps]);

    const getAffiliate = (idAccount: number) => {
        const Props = { IDAccount: idAccount };
        instance.getAffiliateCatalogPorPropiedades(Props, null).then(resp => {
            if (resp.length > 0) {
                getAccInforpo(resp[0].DataBeanProperties.IDAccount, resp[0].DataBeanProperties);
            } else {
                toast.error("No se encontro información del usuario");
            }
        }).catch(err => {
            console.error(err);
            toast.error("Error al cargar la información del usuario");
        });
    };

    const getAccInforpo = (IDAccount, objeto) => {
        accF.instance.getAccountbyID(IDAccount).then(
            (resp) => {
                setBean({ ...objeto, Nit: objeto.Nit ?? resp.Nit, SegundoApellido: objeto.SegundoApellido ?? resp.Surname2, PrimerApellido: objeto.PrimerApellido ?? resp.Surname1, PrimerNombre: objeto.PrimerNombre ?? resp.Name1, SegundoNombre: objeto.SegundoNombre ?? resp.Name2, CorreoPersonal: objeto.CorreoPersonal ?? resp.eMail })
            }
        ).catch(
            err => {
                toast.error("no se pudo migrar la información")
            }
        )
    }

    const updateAffiliate = () => {
        const updatedBean = { ...bean, JSONProps: JSON.stringify(props), SyncDate: _single.getCurrenDate() };
        instance.updateAffiliate(updatedBean).then(resp => {
            toast.success("Se actualizó la información del usuario");
            onClickSave?.(updatedBean);
            getAffiliate(idAffiliate)
        })
            .catch(err => console.error(err));
    };

    const taps = [
        { id: 0, name: 'Información Básica', disable: false },
        { id: 1, name: 'Referencias', disable: false },
        { id: 2, name: 'Documentos', disable: false },
        { id: 3, name: 'Cuentas Bancarias', disable: false },
    ];

    const getTimeDiffText = (fechaInicio: string | Date) => {
        if (!fechaInicio) return "";
        const start = new Date(fechaInicio);
        const now = new Date();
        const diffInMs = now.getTime() - start.getTime();
        const diffInDays = Math.floor(diffInMs / (1000 * 60 * 60 * 24));
        const years = Math.floor(diffInDays / 365);
        const months = Math.floor((diffInDays % 365) / 30);
        const days = (diffInDays % 365) % 30;
        return `${years} año(s), ${months} mes(es), ${days} día(s)`;
    };

    if (showOnlyTabId !== undefined) {
        if (showOnlyTabId === 0) {
            return (
                <div className="row p-4">
                    <PersonalInfoTab
                        bean={bean}
                        setBean={setBean}
                        props={props}
                        setProps={setProps}
                        missingFields={missingFields}
                        setMissingFields={setMissingFields}
                        updateAffiliate={updateAffiliate}
                        getTimeDiffText={getTimeDiffText}
                    />
                </div>
            );
        } else if (showOnlyTabId === 1) {
            return (
                <div className="row">
                    <div className="col-md-12">
                        <PersonalReferenceTab
                            props={props}
                            setProps={setProps}
                            missingFields={missingFields}
                            setMissingFields={setMissingFields}
                            updateAffiliate={updateAffiliate}
                        />
                    </div>
                </div>
            )
        } else if (showOnlyTabId === 2) {
            return (
                <div className="row">
                    <div className="col-md-12">
                        <PersonalDocumentsTab _payrollType={_PayrollType} _loanLine={_LoanLine} idAccount={idAffiliate} updateAffiliate={updateAffiliate} type={type} />
                    </div>
                </div>
            )
        } else if (showOnlyTabId === 3) {
            return (
                <div className="row">
                    <div className="col-md-12">
                        <ThirdBankingAccount cannotEdit isModal idAccount={idAffiliate} />
                    </div>
                </div>
            )
        }
        return null;
    }

    return (
        <div className="row p-4">
            {bean.IDAccount ?
                <div className="col-md-12">
                    <CardTaps index={indexTap} updateIndex={setIndexTap} taps={taps}>
                        {indexTap === 0 && (
                            <PersonalInfoTab
                                bean={bean}
                                setBean={setBean}
                                props={props}
                                setProps={setProps}
                                missingFields={missingFields}
                                setMissingFields={setMissingFields}
                                updateAffiliate={updateAffiliate}
                                getTimeDiffText={getTimeDiffText}
                                cannotEdit
                            />
                        )}
                        {indexTap === 1 && (
                            <PersonalReferenceTab
                                props={props}
                                setProps={setProps}
                                missingFields={missingFields}
                                setMissingFields={setMissingFields}
                                updateAffiliate={updateAffiliate}
                                cannotEdit
                            />
                        )}
                        {indexTap === 2 && (
                            <PersonalDocumentsTab cannotEdit _payrollType={_PayrollType} _loanLine={_LoanLine} idAccount={idAffiliate} updateAffiliate={updateAffiliate} type={type} />
                        )}
                        {indexTap === 3 && (
                            <div className="row">
                                <div className="col-md-12">
                                    <ThirdBankingAccount cannotEdit  isModal idAccount={idAffiliate} />
                                </div>
                            </div>
                        )}
                    </CardTaps>
                </div>
                :
                <Alert children={`No se Encontro información del usuario`} clase='info text-center' />
            }
        </div>
    );
};
